import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var viewBox = "0 0 379.5 134.4";
var height = "24px";
var Hertz = function() {
    return /*#__PURE__*/ _jsxs("svg", {
        role: "img",
        "aria-label": "Hertz",
        viewBox: viewBox,
        height: height,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "#ffd100",
                d: "M353.6 134.4H0l4-19.1h353.7z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M268.8 82.4c-3.2-3.4-1.3-10.2.3-17.8l5.5-25.9h22.7l4.1-19.3h-22.7l4-19.3h-21.4l-14 66.3c-2.1 9.9-2.9 17.7 1.4 26 4 7.8 17.7 15.2 34.9 10.5l3.8-17.9c-11.5 1.4-16.3-.1-18.6-2.6zM87.7.1L77.5 48H39.9L50.1.1H28.5L6.7 102.9h21.6l7.5-35.6h37.6l-7.6 35.6h21.4L109 .1zM210.9 26.6c-7.5 6.3-11.7 14.4-14.5 27.4L186 102.9h21.4l8.6-40.6c2-9.5 3.6-15.4 7.2-19.1 4.9-5 12-5.3 20.5-4.6l4.1-19.3a41.1 41.1 0 0 0-36.9 7.3zM378 19.3h-66.8l-4.1 19.4h38.8l-48.5 45.6-3.9 18.6h66.8l4.1-19.3h-39l48.7-45.9zM152.5 17.8c-7.2 0-17.1 2.2-26.8 9.9-21.9 17.2-32.8 76.7 14.3 76.7a61 61 0 0 0 35.2-11L166.7 79c-7.1 5.5-43 17.4-39.2-11.7h56.1c0-.1 7.1-23.3-3.1-37.4-8.9-11.9-25-12.1-28-12.1zm13.9 31.9h-34.3c1.2-4.6 8.5-16 22-14.7 14.6 1.3 12.3 14.7 12.3 14.7z"
            }),
            /*#__PURE__*/ _jsxs("g", {
                id: "Registered_Trademark_2_",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        fill: "#939598",
                        d: "M374.8 92.2s-.1 0 0 0a7.8 7.8 0 0 0-7.3 6l-.1 1.3c0 2.6 1.9 4.7 4.8 4.7 3.3 0 6.5-2.7 7.2-6l.1-1.2c0-2.8-1.9-4.8-4.7-4.8zm3.8 5.7a7 7 0 0 1-6.4 5.3c-2.5 0-3.9-1.6-4-3.8l.1-1.1a7 7 0 0 1 6.4-5.3c2.6 0 4 1.6 4 3.9l-.1 1z"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        fill: "#939598",
                        d: "M374.3 95.3h-2.5l-1.2 5.7h1.3l.4-1.8h1l.8 1.8h1.5l-1-2c.8-.3 1.4-.9 1.6-1.8.2-1.3-.6-1.9-1.9-1.9zm.5 1.9c-.1.5-.5.8-1.2.8h-1.2l.4-1.7h1.2c.6.1.9.4.8.9z"
                    })
                ]
            })
        ]
    });
};
// eslint-disable-next-line import/no-default-export
export default Hertz;
